
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M22.091 13.091h7.364M22.091 19.636h7.364M17.182 22.91H5.727h0a4.909 4.909 0 014.91-4.91h1.636a4.909 4.909 0 014.909 4.91h0z"}}),_c('circle',{attrs:{"cx":"11.455","cy":"12.273","r":"3.273"}}),_c('path',{attrs:{"d":"M29.455 0a3.273 3.273 0 01-6.546 0h-9.818a3.273 3.273 0 01-6.546 0H0v29.455h36V0h-6.545z"}})])])
          )
        }
      }
    